import { useIntl } from 'react-intl';
import { messages } from '../localization/messages.ts';
import { useCallback } from 'react';
import { useAudioRecorderContext } from '../contexts/recorder.tsx';
import { useMessagingStore } from './useMessagingStore.tsx';

/** Uses the one microphone owner selected by the runtime's advertised voice engine. */
export function useVoiceToggle(): () => void {
  const intl = useIntl();
  const store = useMessagingStore();
  const { enableMicrophone, disableMicrophone } = useAudioRecorderContext();
  return useCallback(() => {
    if (store.voiceEngine === 'realtime') {
      store.toggleSpeech();
      return;
    }
    if (store.speechEnabled) {
      store.toggleSpeech();
      void disableMicrophone();
      return;
    }
    store.toggleSpeech();
    store.setVoiceState('connecting');
    void enableMicrophone()
      .then(() => {
        if (store.speechEnabled) {
          store.setVoiceState('listening');
        }
      })
      .catch((error: unknown) => {
        if (error instanceof DOMException && error.name === 'AbortError') {
          return;
        }
        if (store.speechEnabled) {
          store.toggleSpeech();
        }
        store.notificationsStore.addNotification({
          type: 'error',
          source: 'voice',
          message: intl.formatMessage(messages.voiceStartFailed),
        });
      });
  }, [store, intl, enableMicrophone, disableMicrophone]);
}
